import { configureStore } from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { createLogger } from 'redux-logger'

import { dodgeQuery } from "./api.slice";


const loggerMiddleware = () => {
  if (process.env.NODE_ENV === 'development') return [createLogger({ collapsed: true })];
  return [];
};

export const store = configureStore({
  reducer: {
    [dodgeQuery.reducerPath]: dodgeQuery.reducer,
  },
  middleware: initMiddleware => initMiddleware().concat(dodgeQuery.middleware).concat(loggerMiddleware()),
  devTools: false
})

setupListeners(store.dispatch);